(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fanned-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fanned-gallery')) {
    class FannedGallery extends HTMLElement {
      connectedCallback() {
        this.deck = this.querySelector('.fanned-gallery__deck');
        this.cards = Array.from(this.querySelectorAll('.fanned-gallery__card'));
        this.count = this.cards.length;
        if (!this.count) return;
        this.angle = parseFloat(this.dataset.angle) || 8;
        this.autoplay = parseInt(this.dataset.autoplay, 10) || 0;
        this.active = Math.floor((this.count - 1) / 2);
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.cards.forEach((card, i) => {
          card.addEventListener('mouseenter', () => this.activate(i));
          card.addEventListener('focusin', () => this.activate(i));
          card.addEventListener('click', () => this.activate(i));
        });

        this.addEventListener('pointerenter', () => this.stop());
        this.addEventListener('pointerleave', () => this.play());

        this.#ro = new ResizeObserver(() => this.layout());
        this.#ro.observe(this);

        // Reveal once visible, then fan out + start the cycle.
        const io = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              this.layout();
              requestAnimationFrame(() => this.deck.removeAttribute('data-not-ready'));
              this.play();
              io.disconnect();
            }
          });
        }, { threshold: 0.2 });
        io.observe(this);

        this.layout();
      }

      disconnectedCallback() { this.stop(); this.#ro && this.#ro.disconnect(); }

      #ro;
      #timer;

      layout() {
        const cardW = this.cards[0].offsetWidth || 200;
        const avail = this.deck.clientWidth || this.offsetWidth || 1000;
        const n = this.count;
        const center = (n - 1) / 2;

        // Spacing: overlap cards, but never exceed the container width.
        const maxSpacing = n > 1 ? (avail - cardW) / (n - 1) : 0;
        const spacing = Math.max(0, Math.min(cardW * 0.58, maxSpacing));

        // Cap the total fan angle so big decks don't over-rotate.
        const totalAngle = Math.min(this.angle * (n - 1), 54);
        const perCard = n > 1 ? totalAngle / (n - 1) : 0;
        const arc = Math.min(cardW * 0.12, 26);

        this.base = this.cards.map((_, i) => {
          const off = i - center;
          return {
            tx: off * spacing,
            ty: off * off * (arc / Math.max(1, center * center || 1)),
            rot: off * perCard,
            z: 100 - Math.round(Math.abs(off) * 10),
          };
        });

        // Deck height = card height + lift + arc room.
        const cardH = this.cards[0].querySelector('.fanned-gallery__card-inner')?.offsetHeight || cardW * 1.33;
        this.deck.style.setProperty('--fg-deck-h', Math.round(cardH + arc + 56) + 'px');

        this.render();
      }

      render() {
        if (!this.base) return;
        this.cards.forEach((card, i) => {
          const b = this.base[i];
          const isActive = i === this.active;
          card.classList.toggle('is-active', isActive);
          const tx = b.tx;
          const ty = isActive ? -28 : b.ty;
          const rot = isActive ? 0 : b.rot;
          const s = isActive ? 1.08 : 1;
          const z = isActive ? 1000 : b.z;
          card.style.setProperty('--tx', tx + 'px');
          card.style.setProperty('--ty', ty + 'px');
          card.style.setProperty('--rot', rot + 'deg');
          card.style.setProperty('--s', s);
          card.style.setProperty('--z', z);
        });
      }

      activate(i) {
        this.active = i;
        this.render();
        // Pause autoplay briefly after manual interaction
        this.stop();
        clearTimeout(this.#resume);
        this.#resume = setTimeout(() => this.play(), 4000);
      }
      #resume;

      play() {
        if (!this.autoplay || this.reduced) return;
        this.stop();
        this.#timer = setInterval(() => {
          this.active = (this.active + 1) % this.count;
          this.render();
        }, this.autoplay);
      }

      stop() { clearInterval(this.#timer); }
    }
    customElements.define('fanned-gallery', FannedGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-tool-hint"] && !Shopify.designMode) return;
  try {
    
  // Smooth-scroll to the tool when the hint button is clicked.
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-logo-tool-hint]');
    if (!link) return;
    const id = (link.getAttribute('href') || '').replace('#', '');
    const target = id && document.getElementById(id);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.replaceState(null, '', link.getAttribute('href'));
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-whitener"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('logo-whitener')) {
    class LogoWhitener extends HTMLElement {
      connectedCallback() {
        this.fileInput = this.querySelector('input[type="file"]');
        this.dropZone = this.querySelector('.logo-whitener__drop');
        this.canvas = this.querySelector('canvas');
        this.previewArea = this.querySelector('.logo-whitener__preview');
        this.downloadBtn = this.querySelector('.logo-whitener__download');
        this.tolerance = Number(this.dataset.tolerance) || 80;
        this.fillMode = this.dataset.fillMode || 'detail';

        this.fileInput.addEventListener('change', (e) => {
          const file = e.target.files && e.target.files[0];
          if (file) this.handleFile(file);
        });

        ['dragenter', 'dragover'].forEach((evt) =>
          this.dropZone.addEventListener(evt, (e) => {
            e.preventDefault();
            this.dropZone.setAttribute('data-dragging', 'true');
          })
        );
        ['dragleave', 'drop'].forEach((evt) =>
          this.dropZone.addEventListener(evt, (e) => {
            e.preventDefault();
            this.dropZone.removeAttribute('data-dragging');
          })
        );
        this.dropZone.addEventListener('drop', (e) => {
          const file = e.dataTransfer?.files?.[0];
          if (file) this.handleFile(file);
        });

        this.downloadBtn.addEventListener('click', () => this.download());
      }

      handleFile(file) {
        if (!file.type.startsWith('image/')) return;
        this.originalName = (file.name || 'logo').replace(/\.[^.]+$/, '');
        const url = URL.createObjectURL(file);
        const img = new Image();
        img.onload = () => {
          this.process(img);
          URL.revokeObjectURL(url);
        };
        img.onerror = () => URL.revokeObjectURL(url);
        img.src = url;
      }

      process(img) {
        // Work at higher resolution than before (cleaner print output);
        // still capped so the flood-fill stays fast on huge uploads.
        const MAX = 2200;
        const scale = Math.min(1, MAX / Math.max(img.width, img.height));
        const w = Math.max(1, Math.round(img.width * scale));
        const h = Math.max(1, Math.round(img.height * scale));
        this.canvas.width = w;
        this.canvas.height = h;
        const ctx = this.canvas.getContext('2d', { willReadFrequently: true });
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        ctx.clearRect(0, 0, w, h);
        ctx.drawImage(img, 0, 0, w, h);

        const imgData = ctx.getImageData(0, 0, w, h);
        const data = imgData.data;
        const n = w * h;
        const step = Math.max(1, Math.floor(Math.min(w, h) / 120));

        // --- Detect a transparent background by sampling the border alpha ---
        let aSum = 0, aCnt = 0;
        for (let x = 0; x < w; x += step) {
          aSum += data[x * 4 + 3] + data[((h - 1) * w + x) * 4 + 3];
          aCnt += 2;
        }
        for (let y = 0; y < h; y += step) {
          aSum += data[y * w * 4 + 3] + data[(y * w + w - 1) * 4 + 3];
          aCnt += 2;
        }
        const transparentBg = aSum / aCnt < 30;

        if (transparentBg) {
          // Already-transparent PNG: just paint visible pixels white,
          // keep original alpha (preserves anti-aliasing).
          for (let i = 0; i < data.length; i += 4) {
            if (data[i + 3] > 0) { data[i] = 255; data[i + 1] = 255; data[i + 2] = 255; }
          }
          ctx.putImageData(imgData, 0, 0);
          this.#finish();
          return;
        }

        // --- Detect background color from the whole border (robust avg) ---
        let bgR = 0, bgG = 0, bgB = 0, cnt = 0;
        const sample = (i) => { bgR += data[i]; bgG += data[i + 1]; bgB += data[i + 2]; cnt++; };
        for (let x = 0; x < w; x += step) { sample(x * 4); sample(((h - 1) * w + x) * 4); }
        for (let y = 0; y < h; y += step) { sample(y * w * 4); sample((y * w + w - 1) * 4); }
        bgR /= cnt; bgG /= cnt; bgB /= cnt;

        const tol = this.tolerance;
        const tol2 = tol * tol;
        const tolHalf = tol * 0.5;
        const outA = new Uint8ClampedArray(n);

        if (this.fillMode === 'silhouette') {
          // --- SILHOUETTE: flood-fill from the borders, then fill the
          //     whole shape solid white. Enclosed areas stay white. ---
          const isBg = (i) => {
            const dr = data[i] - bgR, dg = data[i + 1] - bgG, db = data[i + 2] - bgB;
            return dr * dr + dg * dg + db * db <= tol2;
          };
          const removed = new Uint8Array(n);
          const stack = new Int32Array(n);
          let sp = 0;
          const seed = (p) => { if (!removed[p] && isBg(p * 4)) { removed[p] = 1; stack[sp++] = p; } };
          for (let x = 0; x < w; x++) { seed(x); seed((h - 1) * w + x); }
          for (let y = 0; y < h; y++) { seed(y * w); seed(y * w + w - 1); }
          while (sp > 0) {
            const p = stack[--sp];
            const x = p % w, y = (p - x) / w;
            if (x > 0) seed(p - 1);
            if (x < w - 1) seed(p + 1);
            if (y > 0) seed(p - w);
            if (y < h - 1) seed(p + w);
          }
          for (let p = 0; p < n; p++) {
            if (removed[p]) { outA[p] = 0; continue; }
            const x = p % w, y = (p - x) / w;
            const boundary =
              (x > 0 && removed[p - 1]) || (x < w - 1 && removed[p + 1]) ||
              (y > 0 && removed[p - w]) || (y < h - 1 && removed[p + w]);
            if (boundary) {
              const i = p * 4;
              const dr = data[i] - bgR, dg = data[i + 1] - bgG, db = data[i + 2] - bgB;
              outA[p] = Math.round(Math.min(1, Math.sqrt(dr * dr + dg * dg + db * db) / tol) * 255);
            } else {
              outA[p] = 255;
            }
          }
        } else {
          // --- DETAIL (default): cut EVERY background-coloured pixel,
          //     inside and out. Inner fills become transparent so outlines
          //     + text read as white line-art (no solid blob). ---
          for (let p = 0; p < n; p++) {
            const i = p * 4;
            const dr = data[i] - bgR, dg = data[i + 1] - bgG, db = data[i + 2] - bgB;
            const dist = Math.sqrt(dr * dr + dg * dg + db * db);
            if (dist <= tolHalf) outA[p] = 0;
            else if (dist >= tol) outA[p] = 255;
            else outA[p] = Math.round(((dist - tolHalf) / (tol - tolHalf)) * 255);
          }
        }

        // --- Whiten everything, apply computed alpha ---
        for (let p = 0; p < n; p++) {
          const i = p * 4;
          data[i] = 255; data[i + 1] = 255; data[i + 2] = 255; data[i + 3] = outA[p];
        }

        ctx.putImageData(imgData, 0, 0);
        this.#finish();
      }

      #finish() {
        this.previewArea.setAttribute('data-state', 'ready');
        this.downloadBtn.removeAttribute('disabled');
      }

      download() {
        if (this.previewArea.getAttribute('data-state') !== 'ready') return;
        this.canvas.toBlob((blob) => {
          if (!blob) return;
          const a = document.createElement('a');
          a.href = URL.createObjectURL(blob);
          a.download = (this.originalName || 'logo') + '-white.png';
          document.body.appendChild(a);
          a.click();
          a.remove();
          setTimeout(() => URL.revokeObjectURL(a.href), 1000);
        }, 'image/png');
      }
    }
    customElements.define('logo-whitener', LogoWhitener);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
